import { EventIconAndTime } from "@ihs-widget/components/StatsConsole/Widgets/OverviewWidget/parts/EventIconAndTime";
import { MatchPlayerNameAndScore  } from "@ihs-widget/components/StatsConsole/Widgets/OverviewWidget/parts/MatchPlayerNameAndScore";
import { formatEventTime } from "@ihs-widget/utils/functions";
import type { IMatchGoalProps } from "@ihs-widget/components/StatsConsole/Widgets/OverviewWidget/parts/interfaces";


const MatchEventGoalAway = ({ home_score, away_score, time, goalscorer, assistant, event_type, isPlusSignNeeded = false }: IMatchGoalProps) => {
    const formattedTime = formatEventTime(time, isPlusSignNeeded);
    return (
        <div 
            data-testid="overview-goal-away"
            className='flex justify-end mx-[16px] mb-[8px] min-h-[34px] max-h-[34px]'>
            <MatchPlayerNameAndScore 
                ml="0px" 
                mr="8px" 
                startPosition='end' 
                event_type={event_type} 
                player={goalscorer} 
                assistant={assistant} 
                homeScore={home_score}
                awayScore={away_score}
                isHomeGoal={false}
            />
            <EventIconAndTime iconName={event_type} time={formattedTime} />
        </div>
    )
}

export default MatchEventGoalAway;
